export type BusinessRole = 'user' | 'admin' | 'customer_service' | 'agent' | 'system_messager'

export const BUSINESS_ROLES: readonly BusinessRole[] = [
  'user',
  'admin',
  'customer_service',
  'agent',
  'system_messager',
] as const
